import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { VisualSectionComponent } from '@knorr-bremse-portals/ngx-components/components/visual-section';

class HeroPictureComponent {
    constructor() {
        this.onFirstPage = true;
        this.fallbackVariants = [{ aspectRatio: AspectRatio.Standard }];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: HeroPictureComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: HeroPictureComponent, isStandalone: true, selector: "kb-hero-picture", inputs: { variants: "variants", picture: "picture", alt: "alt", rootColumns: "rootColumns", heading: "heading", abstract: "abstract", link: "link", onFirstPage: "onFirstPage" }, ngImport: i0, template: "<kb-visual-section [abstract]=\"abstract\" [heading]=\"heading\" [link]=\"link\" [colorVariant]=\"true\" [headingLevel]=\"2\">\n  <kb-picture [aboveFold]=\"onFirstPage\" [picture]=\"picture\" [variants]=\"variants ?? fallbackVariants\" [alt]=\"alt\" [rootColumns]=\"rootColumns\"></kb-picture>\n</kb-visual-section>\n", styles: [""], dependencies: [{ kind: "component", type: VisualSectionComponent, selector: "kb-visual-section", inputs: ["heading", "headingLevel", "abstract", "link", "colorVariant", "headingLines", "abstractLines"] }, { kind: "component", type: PictureComponent, selector: "kb-picture", inputs: ["variants", "rootColumns", "picture", "alt", "draggable", "aboveFold"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: HeroPictureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'kb-hero-picture', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [VisualSectionComponent, PictureComponent], template: "<kb-visual-section [abstract]=\"abstract\" [heading]=\"heading\" [link]=\"link\" [colorVariant]=\"true\" [headingLevel]=\"2\">\n  <kb-picture [aboveFold]=\"onFirstPage\" [picture]=\"picture\" [variants]=\"variants ?? fallbackVariants\" [alt]=\"alt\" [rootColumns]=\"rootColumns\"></kb-picture>\n</kb-visual-section>\n" }]
        }], propDecorators: { variants: [{
                type: Input
            }], picture: [{
                type: Input,
                args: [{ required: true }]
            }], alt: [{
                type: Input,
                args: [{ required: true }]
            }], rootColumns: [{
                type: Input,
                args: [{ required: true }]
            }], heading: [{
                type: Input
            }], abstract: [{
                type: Input
            }], link: [{
                type: Input
            }], onFirstPage: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { HeroPictureComponent };
